import {ROULETTE_LIST_BETTING} from "./constant";


const init = {
    betList: [],
    summary: {
        total: 0,
        currency: "",
        currencySignal: ""

    }
}


export default (state = init, {type, payload}) => {
    switch (type) {
        case ROULETTE_LIST_BETTING:
            return {
                ...state,
                ...payload,
            }
        default:
            return state;
    }
}
